import React from 'react';
import { FlameIcon } from 'lucide-react';
type Props = {
  tone?: 'dark' | 'light';
  label?: string;
};
export function ScarcityBar({
  tone = 'dark',
  label = 'Limited promotional spots available'
}: Props) {
  const isLight = tone === 'light';
  return <div className={`w-full rounded-xl border px-4 py-3.5 ${isLight ? 'border-ink-900/15 bg-white' : 'border-white/10 bg-white/[0.04]'}`} data-id="element-50" data-mp="2l2tns8wk53jw">
      <div className="flex items-center justify-between gap-3" data-id="element-51" data-mp="2b5fb8kdr8ywv">
        <span className={`flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide sm:text-xs ${isLight ? 'text-ink-700' : 'text-steel-300'}`} data-id="element-52" data-mp="2g6w9e84uu79r">
          <FlameIcon className="h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-53" data-mp="275y3tlerprp2" />
          {label}
        </span>
        <span className="shrink-0 font-display text-base font-extrabold text-red-500 sm:text-lg" data-id="element-54" data-mp="f8eei9eiotl">
          93% CLAIMED
        </span>
      </div>

      <div className={`mt-2.5 h-3 w-full overflow-hidden rounded-full ${isLight ? 'bg-steel-200' : 'bg-white/10'}`} role="progressbar" aria-valuenow={93} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-55" data-mp="33mmweym12hxp">
        <div className="h-full w-[93%] rounded-full bg-red-600" data-id="element-56" data-mp="38d392gi0xzj0" />
      </div>

      <p className={`mt-2 text-center text-[11px] font-bold uppercase tracking-wide sm:text-xs ${isLight ? 'text-ink-800' : 'text-white'}`} data-id="element-57" data-mp="2ko0szd31geqm">
        Only <span className="text-red-500" data-id="element-58" data-mp="2goiaenyowfqy">7 spots left</span> at the $27 promotional price
      </p>
    </div>;
}